import { IconCurrencyDollar } from '@tabler/icons-react'

export const FinancialStatsOverview = () => {
    return (
        <section
            className='position-relative'
            style={{
                boxShadow: "0px 4px 3px 0px rgba(126, 126, 126, 0.1)",
                border: "1px solid #e3e3e3",
                borderRadius: "0.625rem",
                backgroundColor: "#fff",
                height: "9rem",
                overflow: 'hidden'
            }}
        >
            <div className='position-absolute px-4 w-100' style={{ top: 16, }}>
                <span className="d-block mb-0 pb-0" style={{ fontWeight: 500, fontSize: '16px', }}>Finance Overview</span>

                <div className='d-flex justify-content-around pt-3' style={{ gap: "3.5rem" }}>
                    <div className="pe-5 border-end d-flex flex-column align-items-end" style={{ textWrap: 'nowrap' }}>
                        <span className="text-dark fw-medium " style={{ fontSize: "14.5px" }}>Active Client</span>
                        <h4 className=" mb-0" style={{ fontWeight: 400, fontSize: "1.8rem", color: "#0f172a" }}>245</h4>
                    </div>
                    <div className="pe-5 border-end d-flex flex-column align-items-end" style={{ textWrap: 'nowrap' }}>
                        <span className="text-dark fw-medium" style={{ fontSize: "14.5px" }}>Refund</span>
                        <h4 className=" mb-0" style={{ fontWeight: 400, fontSize: "1.8rem", color: "#0f172a" }}><IconCurrencyDollar stroke={3} />7,380</h4>
                    </div>
                    <div className="pe-5 border-end d-flex flex-column align-items-end" style={{ textWrap: 'nowrap' }}>
                        <span className="text-dark fw-medium" style={{ fontSize: "14.5px" }}>Net Profit</span>
                        <h4 className=" mb-0" style={{ fontWeight: 400, fontSize: "1.8rem", color: "#0f172a" }}><IconCurrencyDollar stroke={3} />25,800</h4>
                    </div>
                    <div className='d-flex flex-column align-items-end' style={{ textWrap: 'nowrap' }}>
                        <span className="text-dark fw-medium" style={{ fontSize: "14.5px" }}>Tax Collected</span>
                        <h4 className=" mb-0" style={{ fontWeight: 400, fontSize: "1.8rem", color: "#0f172a" }}><IconCurrencyDollar stroke={3} />19,800</h4>
                    </div>
                </div>

            </div>
        </section>
    )
}
